/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_home_hero_line2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Work smarter.`)
};

const es_home_hero_line2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabaja más inteligente.`)
};

const de_home_hero_line2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smarter arbeiten.`)
};

const nl_home_hero_line2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Werk slimmer.`)
};

const fr_home_hero_line2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Travaillez plus intelligemment.`)
};

const it_home_hero_line2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lavora più intelligente.`)
};

const pt_br2_home_hero_line2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabalhe mais inteligente.`)
};

const pt_home_hero_line2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabalhe de forma mais inteligente.`)
};

const ja_home_hero_line2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スマートに働く。`)
};

const zh_home_hero_line2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更聪明地工作。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const home_hero_line2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.home_hero_line2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("home_hero_line2", locale)
	if (locale === "en") return en_home_hero_line2(inputs)
	if (locale === "es") return es_home_hero_line2(inputs)
	if (locale === "de") return de_home_hero_line2(inputs)
	if (locale === "nl") return nl_home_hero_line2(inputs)
	if (locale === "fr") return fr_home_hero_line2(inputs)
	if (locale === "it") return it_home_hero_line2(inputs)
	if (locale === "pt-BR") return pt_br2_home_hero_line2(inputs)
	if (locale === "pt") return pt_home_hero_line2(inputs)
	if (locale === "ja") return ja_home_hero_line2(inputs)
	return zh_home_hero_line2(inputs)
};